import React from 'react'

const Donation = () => {
    return (
        <div className="overflow-hidden bg-white py-24 sm:py-32">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
              <div className="lg:pr-8 lg:pt-4">
            <div className="lg:max-w-lg">
                  <p className="mt-2 text-3xl font-bold tracking-tight text-black-900 sm:text-4xl">
                    Support Our Temple:
                  </p>
                  <p className="mt-6 text-lg leading-8 text-black-600">
                    Your contribution helps sustain the spiritual, cultural, and community‑focused programs that make our temple a place of peace, service, and shared tradition. By supporting Shirdi Saidham Temple, you help preserve sacred practices, fund charitable initiatives, and ensure that future generations have a welcoming space to learn, gather, and grow. Every donation—big or small—directly strengthens our community and keeps this sacred home thriving.
                  </p>
                  <p className="mt-6 text-lg leading-8 text-black-600">
                    Shirdi Saidham Temple is a 501(c)(3) IRS‑certified nonprofit organization registered in the state of Washington, and all contributions are fully tax‑deductible.
                  </p>
                  <p className="mt-6 text-lg leading-8 text-black-300">
                    <a href="https://www.paypal.com/paypalme/SaiParivarFoundation" target="_blank" rel="noreferrer">
              Click here to Donate
            </a>
                </p>
                </div>
        </div>

                </div>
              </div>
              </div>
    )
}

export default Donation
            